import { call, select, takeEvery, put } from 'redux-saga/effects'
import {
  EDIT_ASSIGNMENT,
  GET_APPLICANT_DETAILS,
  GET_OFFER_FROM_LIGHT_ENTRE,
  GET_TOTAL_APPLICATIONS,
  PIN_APPLICATION,
  PREVIEW_ASSIGNMENT,
  REJECT_APPLICATION,
  SIGN_SEND_CONTRACT,
  UPDATE_APPLICATION_STATUS,
  UPDATE_VIEW_APPLICATION,
  UPDATE_REVIEW_APPLICATION
} from '../../constants/employer'
import { API_SERVER } from '../../constants'
import { apiBlobPost, apiManualPost } from '../../utils/employer/request'
import {
  getContactName,
  getLoggedInEmail,
  getUuid
} from '../../selectors/employer/client.selector'
import {
  getApplicantDetailsFailed,
  getApplicantDetailsSuccess,
  updateReviewApplicationFailed,
  updateReviewApplicationSuccess,
  getApplicantDetails,
  getTotalApplicationsSuccess,
  getTotalApplicationsFailed,
  getTotalApplications,
  rejectApplicationSuccess,
  rejectApplicationFailed,
  previewAssignmentSuccess,
  previewAssignmentFailed,
  loadPreviewPdf,
  closeLoadPreviewPdf,
  signSendContractSuccess,
  signSendContractFailed,
  filterApplicants,
  loadSignAndSend,
  closeLoadSignAndSend,
  updateApplicationStatusSuccess,
  updateApplicationStatusFailed,
  updateApplicationStatus,
  getOfferFromLightEntreSuccess,
  getOfferFromLightEntreFailed,
  pinApplicationSuccess,
  pinApplicationFailed,
  getOfferFromLightEntre,
  getLightEntrepreneurs
} from '../../actions/employer'
import {
  getFilterJobID,
  getFormValues,
  getOfferToPerson,
  getEmployerInfo
} from '../../selectors/employer/applications.selector'
import { updateFormValues } from '../../form'
import moment from 'moment'
import { contractContent } from '../../utils/openForWork.utils'
import {
  getLatestAssignmentData,
  getOfferToEntrepreneur,
  getPreviewFormValues
} from '../../selectors/employer/assignments.selector'

function* getApplicantDetailsSaga() {
  try {
    const url = `${API_SERVER}/GetAssignmentApplicantDetails`
    const uuid = yield select(getUuid)
    const filterJobID = yield select(getFilterJobID)
    const body = JSON.stringify({
      uuid: uuid
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    if (result.data) {
      yield put(getApplicantDetailsSuccess(resultParsed))
      if (filterJobID !== '') {
        yield put(filterApplicants(filterJobID))
      }
    }
    yield put(getLightEntrepreneurs())
    yield put(getTotalApplications())
  } catch (error) {
    yield put(getApplicantDetailsFailed(error))
  }
}

function* getTotalApplicationsSaga() {
  try {
    const url = `${API_SERVER}/GetAssignmentApplicantDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid,
      totalapplicationcount: true
    })
    const result = yield call(apiManualPost, url, body)
    yield put(getTotalApplicationsSuccess(result.data))
  } catch (error) {
    yield put(getTotalApplicationsFailed(error))
  }
}

function* updateReviewedApplicationDetailsSaga({ uuid, appID, appJobID }) {
  try {
    const url = `${API_SERVER}/UpdateAssignmentApplicantDetails`

    const body = JSON.stringify({
      applicationid: appID,
      appliedpersonuuid: uuid,
      appliedjobid: appJobID,
      isapplicationreviewed: 'yes'
    })

    const result = yield call(apiManualPost, url, body)
    yield put(updateReviewApplicationSuccess(result.data))
    yield put(getApplicantDetails())
    yield put(getOfferFromLightEntre())
  } catch (error) {
    yield put(updateReviewApplicationFailed(error))
  }
}

function* updateViewedApplicationSaga({ agreementId }) {
  try {
    const url = `${API_SERVER}/UpdateAssignmentApplicantDetails`

    const body = JSON.stringify({
      agreementId: agreementId,
      isContractViewed: 1
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Viewed contract details are updated successfully') {
      yield put(getOfferFromLightEntre())
    }
  } catch (error) {}
}

// Update application status
function* updateApplicationStatusSaga({
  status,
  appliedjobid,
  appliedpersonuuid,
  appliedpersonemail,
  applicationid
}) {
  try {
    const url = `${API_SERVER}/UpdateAssignmentApplicantDetails`

    const body = JSON.stringify({
      applicationid: applicationid,
      appliedpersonuuid: appliedpersonuuid,
      appliedpersonemail: appliedpersonemail,
      appliedjobid: appliedjobid,
      applicationstatus: status,
      isapplicationreviewed: 'no'
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data !== 'Application status updated successfully') {
      yield put(updateApplicationStatusSuccess(data))
      yield put(getApplicantDetails())
      yield put(getOfferFromLightEntre())
    }
  } catch (error) {
    yield put(updateApplicationStatusFailed(error))
  }
}

// Reject single applications
function* rejectApplicationSaga({
  appID,
  uuid,
  email,
  appJobID,
  applicantData
}) {
  try {
    const url = `${API_SERVER}/UpdateAssignmentApplicantDetails`
    const employerInfo = yield select(getEmployerInfo)

    const body = JSON.stringify({
      applicationid: appID,
      appliedpersonuuid: uuid,
      appliedpersonemail: email,
      appliedjobid: appJobID,
      applicationstatus: 'Employer rejected',
      isapplicationreviewed: '',

      employername: employerInfo.company_name,
      employeremail: employerInfo.email,

      applicantfirstname: applicantData.firstname,
      jobtitle: applicantData.job_title,
      employerdetails: [
        {
          companyname: employerInfo.company_name
        }
      ]
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data) {
      yield put(rejectApplicationSuccess(result.data))
      yield put(getApplicantDetails())
      yield put(getOfferFromLightEntre())
    }
  } catch (error) {
    yield put(rejectApplicationFailed(error))
  }
}

function* editAssignmentSaga() {
  try {
    const formValues = yield select(getFormValues)
    yield put(updateFormValues('contractForm', formValues))
  } catch (error) {}
}
// Helper function for mapping values
const mapValue = (mapping, key, defaultValue = 'Unknown') =>
  mapping[key] || defaultValue

// Define mappings for salary_model and assignment_type
const salaryModelMapping = {
  hourly_rate: 'Hourly rate',
  contract_price: 'Contract price',
  unit_price: 'Unit price',
  commission: 'Commission'
}

const assignmentTypeMapping = {
  until_further_notice: 'Until further notice',
  temporary: 'Temporary',
  temporary_with_notice: 'Temporary with a notice period',
  until_completion: 'So far until completion'
}

function* previewAssignmentSaga({ formData, isDirectOffer }) {
  // There is formData values when preview the assignment agreement from Assignments page
  try {
    yield put(loadPreviewPdf())
    const url = `${API_SERVER}/AssignmentOfferLightEntrepreneurs`
    const offerToPerson = yield select(getOfferToPerson)
    const selectedLightEntrepreneur = yield select(getOfferToEntrepreneur)
    const zip_code = isDirectOffer
      ? selectedLightEntrepreneur.zip_code
      : offerToPerson.zipCode
    const city = isDirectOffer
      ? selectedLightEntrepreneur.city
      : offerToPerson.city
    const info_consent_allowed = isDirectOffer
      ? selectedLightEntrepreneur.info_consent_allowed
      : offerToPerson.info_consent_allowed
    const contactName = yield select(getContactName)
    const uuid = yield select(getUuid)
    const formValues = formData

    // Map salary_model and assignment_type
    const salaryModel = mapValue(salaryModelMapping, formValues.salary_model)
    const assignmentType = mapValue(
      assignmentTypeMapping,
      formValues.assignment_type
    )

    const body = JSON.stringify({
      uuid: uuid,
      contactName: contactName,
      offerlename: isDirectOffer
        ? selectedLightEntrepreneur.firstname +
          ' ' +
          selectedLightEntrepreneur.lastname
        : offerToPerson.fullname,
      offerlezipcode: info_consent_allowed ? zip_code : '',
      offerlecity: info_consent_allowed ? city : '',
      assignmentbegins: moment(formValues.assignment_begins).format(
        'YYYY-MM-DD'
      ),
      assignmentends: formValues?.assignment_ends
        ? moment(formValues.assignment_ends).format('YYYY-MM-DD')
        : '',
      assignmenttype: assignmentType,
      salarymodel: salaryModel,
      expensefee: formValues.isExpensesIncluded === 'yes' ? true : false,
      paymentterms: formValues.payment_terms,
      // hourlyrate: formValues.hourly_rate,
      amount: formValues.amount,
      tilaajasign: null,
      assignmentcontent: formValues.content_assignment,
      additionalterms: formValues.additional_terms,
      previewleagreement: true,
      contractlanguage: formValues.eng_lang ? 'eng' : 'fi',
      ContractInfo: contractContent(
        formValues?.assignment_ends,
        formValues.eng_lang
      )
    })

    yield call(apiBlobPost, url, body)
    yield put(previewAssignmentSuccess(formValues))
    yield put(closeLoadPreviewPdf())
  } catch (error) {
    yield put(previewAssignmentFailed(error))
  }
}

// offeredData: when offeredData is not null => Employer signs for the contract
// Updates data from offerToPerson and formValues to data from offeredData
function* signSendContractSaga({
  trim,
  isDraft,
  offeredData,
  directlySendContract
}) {
  try {
    yield put(loadSignAndSend())
    const url = `${API_SERVER}/AssignmentOfferLightEntrepreneurs`
    const offerToPerson = yield select(getOfferToPerson)
    const selectedLightEntrepreneur = yield select(getOfferToEntrepreneur)
    const zip_code = directlySendContract
      ? selectedLightEntrepreneur.zip_code
      : offerToPerson.zipCode
    const city = directlySendContract
      ? selectedLightEntrepreneur.city
      : offerToPerson.city
    const info_consent_allowed = directlySendContract
      ? selectedLightEntrepreneur.info_consent_allowed
      : offerToPerson.info_consent_allowed
    const email = directlySendContract
      ? selectedLightEntrepreneur.email
      : offerToPerson.email
    const uuid = yield select(getUuid)
    const contactName = yield select(getContactName)
    const loggedEmail = yield select(getLoggedInEmail)
    const formValues = directlySendContract
      ? yield select(getPreviewFormValues)
      : yield select(getFormValues)
    const latestAssignmentData = yield select(getLatestAssignmentData)

    // Map salary_model and assignment_type
    const salaryModel = mapValue(salaryModelMapping, formValues.salary_model)
    const assignmentType = mapValue(
      assignmentTypeMapping,
      formValues.assignment_type
    )

    const body = {
      uuid: uuid,
      contactName: contactName,
      email: loggedEmail,
      offerlename: directlySendContract
        ? selectedLightEntrepreneur.firstname +
          ' ' +
          selectedLightEntrepreneur.lastname
        : offerToPerson.fullname,
      offerlezipcode: info_consent_allowed ? zip_code : '',
      offerlecity: info_consent_allowed ? city : '',
      assignmentid: directlySendContract
        ? latestAssignmentData.assignment_id
        : offerToPerson.appJobID,
      assignmentbegins: moment(formValues.assignment_begins).format(
        'YYYY-MM-DD'
      ),
      assignmentends: formValues?.assignment_ends
        ? moment(formValues.assignment_ends).format('YYYY-MM-DD')
        : '',
      assignmenttype: assignmentType,
      salarymodel: salaryModel,
      expensefee: formValues.isExpensesIncluded === 'yes' ? true : false,
      paymentterms: formValues.payment_terms,
      // hourlyrate: formValues.hourly_rate,
      amount: formValues.amount,
      tilaajasign: isDraft
        ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANsAAAChCAYAAABOOsrnAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAG/SURBVHhe7dMxAQAADMOg+TfducgFHrgBCdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGEdkgIhtEZIOIbBCRDSKyQUQ2iMgGie0B5ZHlMR2PWocAAAAASUVORK5CYII='
        : trim,
      assignmentcontent: formValues.content_assignment,
      additionalterms: formValues.additional_terms,
      previewleagreement: false,
      entrepreneursemail: email,
      contractlanguage: formValues.eng_lang ? 'eng' : 'fi',
      agreementstatus: isDraft ? 'draft' : 'sent',
      ContractInfo: contractContent(
        formValues?.assignment_ends,
        formValues.eng_lang
      ),
      applicantDetails: [
        {
          OfferedAgreementStatusEntrepreneur: 'Offer sent by employer'
        }
      ]
    }

    const result = yield call(
      apiManualPost,
      url,
      JSON.stringify(
        offeredData !== null ? bodyEmployerSigns(offeredData, trim) : body
      )
    )
    if (
      result.data ===
      'Email sent and assignment agreement details for light entrepreneurs are added successfully'
    ) {
      yield put(closeLoadSignAndSend())
      yield put(
        signSendContractSuccess(result.data, trim !== null ? true : false)
      )
      if (!directlySendContract) {
        yield put(
          updateApplicationStatus(
            'Offer sent by employer',
            offerToPerson.appJobID, // assignment id
            offerToPerson.uuid,
            email,
            offerToPerson.appID
          )
        )
      }
      yield put(getApplicantDetails())
      yield put(getOfferFromLightEntre())
    } else {
      yield put(
        signSendContractFailed(result.data, trim !== null ? true : false)
      )
      yield put(closeLoadSignAndSend())
    }
  } catch (error) {
    yield put(signSendContractFailed(error, trim !== null ? true : false))
  }
}

const getContractLanguage = (contractPath) => {
  return contractPath.includes('eng-details') ? 'eng' : 'fi'
}

// Body when employer signs the contract
const bodyEmployerSigns = (offeredData, trim) => {
  let body = {}

  body.uuid = offeredData.uuid
  body.contactName = offeredData.contact_name
  body.email = offeredData.email
  body.offerlename = offeredData.firstname + ' ' + offeredData.lastname
  body.offerlezipcode = offeredData.zip_code
  body.offerlecity = offeredData.city
  body.assignmentid = offeredData.assignment_job_id
  body.assignmentbegins = moment(offeredData.assignment_begins).format(
    'YYYY-MM-DD'
  )
  body.assignmentends = offeredData?.assignment_ends
    ? moment(offeredData.assignment_ends).format('YYYY-MM-DD')
    : ''
  body.assignmenttype = offeredData.assignment_type
  body.salarymodel = offeredData.salary_model
  body.expensefee = offeredData.inc_expensefee
  body.paymentterms = offeredData.payment_terms
  body.amount = offeredData.amount
  body.tilaajasign = trim
  body.assignmentcontent = offeredData.assignment_contents
  body.additionalterms = offeredData.additional_terms
  body.previewleagreement = false
  body.entrepreneursemail = offeredData.offered_entrepreneur_email
  body.contractlanguage = getContractLanguage(offeredData.contract_path)
  body.agreementstatus = 'sent'
  body.ContractInfo = contractContent(
    offeredData?.assignment_ends,
    body.contractlanguage === 'eng'
  )
  body.ApplicantDetails = [
    {
      OldContractURL: offeredData.contract_path,
      OfferedAgreementStatusEntrepreneur: 'Offer signed'
    }
  ]
  body.AssignmentAgreementId = offeredData.agreement_id
  body.EntrepreneurSign = offeredData.entrepreneur_sign

  return body
}

function* getOfferedFromLightEntreSaga() {
  try {
    const url = `${API_SERVER}/GetEmployerOfferedContractDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)
    const directlyOfferData = resultParsed.filter((el) => !el.application_id)
    if (result.data) {
      yield put(getOfferFromLightEntreSuccess(resultParsed, directlyOfferData))
    }
  } catch (error) {
    yield put(getOfferFromLightEntreFailed(error))
  }
}

function* pinApplicationSaga({ application_id, agreement_id }) {
  try {
    const url = `${API_SERVER}/AddPinnedApplicantDetailsEmployer`
    const url_directAgreement = `${API_SERVER}/AddEmployerPinnedDirectAgreementDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      applicantDetails: [{ applicationid: application_id }]
    })
    const body_directAgreement = JSON.stringify({
      employerdetails: [{ uuid: uuid, assignmentAgreementId: agreement_id }]
    })
    const result = yield call(
      apiManualPost,
      application_id !== null ? url : url_directAgreement,
      application_id !== null ? body : body_directAgreement
    )
    if (result.data === 'Pinned applicant details are added successfully') {
      yield put(pinApplicationSuccess(result.data))
    } else {
      yield put(pinApplicationFailed(result.data))
    }
    yield put(getApplicantDetails())
    yield put(getOfferFromLightEntre())
  } catch (error) {
    yield put(pinApplicationFailed(error))
  }
}

export function* watchGetApplicantDetailsSaga() {
  yield takeEvery(GET_APPLICANT_DETAILS, getApplicantDetailsSaga)
}
export function* watchUpdateViewedApplicationSaga() {
  yield takeEvery(UPDATE_VIEW_APPLICATION, updateViewedApplicationSaga)
}
export function* watchUpdateReviewedApplicationDetailsSaga() {
  yield takeEvery(
    UPDATE_REVIEW_APPLICATION,
    updateReviewedApplicationDetailsSaga
  )
}
export function* watchGetTotalApplicationsSaga() {
  yield takeEvery(GET_TOTAL_APPLICATIONS, getTotalApplicationsSaga)
}
export function* watchRejectApplicationSaga() {
  yield takeEvery(REJECT_APPLICATION, rejectApplicationSaga)
}
export function* watchEditAssignmentAppSaga() {
  yield takeEvery(EDIT_ASSIGNMENT, editAssignmentSaga)
}
export function* watchPreviewAssignmentSaga() {
  yield takeEvery(PREVIEW_ASSIGNMENT, previewAssignmentSaga)
}
export function* watchSignSendContractSaga() {
  yield takeEvery(SIGN_SEND_CONTRACT, signSendContractSaga)
}
export function* watchUpdateApplicationStatusSaga() {
  yield takeEvery(UPDATE_APPLICATION_STATUS, updateApplicationStatusSaga)
}
export function* watchGetOfferedFromLightEntreSaga() {
  yield takeEvery(GET_OFFER_FROM_LIGHT_ENTRE, getOfferedFromLightEntreSaga)
}
export function* watchPinApplicationSaga() {
  yield takeEvery(PIN_APPLICATION, pinApplicationSaga)
}
